import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();
  return (
    <section className="relative py-16 bg-background-50">
      <div className="max-w-[600px] mx-auto px-8 text-center">
        <p className="text-[14px] text-foreground-500 tracking-[0.04em] mb-6">
          {t('consultation.cta.note')}
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <Link
            to="/seminar"
            className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 text-foreground-600 hover:text-foreground-800 hover:border-foreground-400 text-[15px] tracking-[0.06em] transition-all duration-300 whitespace-nowrap"
          >
            {t('consultation.cta.seminarBtn')}
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </div>
          </Link>
          <Link
            to="/courses"
            className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 text-foreground-600 hover:text-foreground-800 hover:border-foreground-400 text-[15px] tracking-[0.06em] transition-all duration-300 whitespace-nowrap"
          >
            {t('consultation.cta.coursesBtn')}
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}
